import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import Home from "./components/home";
import AboutUs from "./components/about_us";
import OurProducts from "./components/our_products";
import Menu from "./components/menu";
import Outlet from "./components/outlets";
import Gallery from "./components/gallery";
import Contact from "./components/contact_us";

import "./App.css";
function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about_us" element={<AboutUs />} />
          <Route path="/our_products" element={<OurProducts />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/outlets" element={<Outlet />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact_us" element={<Contact />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}
export default App;
